import { render, staticRenderFns } from "./pchoicequestion.vue?vue&type=template&id=e21f9a76&scoped=true&"
import script from "./pchoicequestion.vue?vue&type=script&lang=js&"
export * from "./pchoicequestion.vue?vue&type=script&lang=js&"
import style0 from "./pchoicequestion.vue?vue&type=style&index=0&id=e21f9a76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21f9a76",
  null
  
)

export default component.exports